module.exports = __webpack_public_path__ + "static/media/Mental_Control.8c64ca9b.mp3";